/* tslint:disable */
/* eslint-disable */
/**
 * API
 * API
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { CommissionCandidatesResponseDto } from '../models';
// @ts-ignore
import type { ExtraCommissionMemberDto } from '../models';
// @ts-ignore
import type { ExtraCommissionMembersResponseDto } from '../models';
// @ts-ignore
import type { InlineObject1Dto } from '../models';
// @ts-ignore
import type { InlineObjectDto } from '../models';
// @ts-ignore
import type { UpsertExtraCommissionMemberRequestDto } from '../models';
/**
 * ExtraCommissionMembersApi - axios parameter creator
 * @export
 */
export const ExtraCommissionMembersApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * People a certification admin added to the commission pool of this EXAM stage on top of the supervisor relations configured in the stage config. While a person is on the list of any certification they hold `certification.exam.day.management` and `admin.panel.access`, and the exam day permission is effective in every stage whose list they are on. 
         * @summary List extra commission members of the exam stage
         * @param {number} certificationId 
         * @param {number} stageId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getExtraCommissionMembers: async (certificationId: number, stageId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'certificationId' is not null or undefined
            assertParamExists('getExtraCommissionMembers', 'certificationId', certificationId)
            // verify required parameter 'stageId' is not null or undefined
            assertParamExists('getExtraCommissionMembers', 'stageId', stageId)
            const localVarPath = `/api/v2/certifications/{certificationId}/stages/{stageId}/exam/extra-commission-members`
                .replace(`{${"certificationId"}}`, encodeURIComponent(String(certificationId)))
                .replace(`{${"stageId"}}`, encodeURIComponent(String(stageId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Refused with 409 while the person sits on the commission of an exam day of this stage that is still DRAFT or IN_PROGRESS. Removing a person who is not on the list is a no-op. 
         * @summary Remove a person from the extra commission members
         * @param {number} certificationId 
         * @param {number} stageId 
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeExtraCommissionMember: async (certificationId: number, stageId: number, userId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'certificationId' is not null or undefined
            assertParamExists('removeExtraCommissionMember', 'certificationId', certificationId)
            // verify required parameter 'stageId' is not null or undefined
            assertParamExists('removeExtraCommissionMember', 'stageId', stageId)
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('removeExtraCommissionMember', 'userId', userId)
            const localVarPath = `/api/v2/certifications/{certificationId}/stages/{stageId}/exam/extra-commission-members/{userId}`
                .replace(`{${"certificationId"}}`, encodeURIComponent(String(certificationId)))
                .replace(`{${"stageId"}}`, encodeURIComponent(String(stageId)))
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Active accounts (enabled, with at least one active role), searched by first name, last name, email or SAP number. `extraMember` is true for people already on this stage\'s list. 
         * @summary Search accounts that can be added as extra commission members
         * @param {number} certificationId 
         * @param {number} stageId 
         * @param {string} [search] 
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchExtraCommissionMemberCandidates: async (certificationId: number, stageId: number, search?: string, page?: number, size?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'certificationId' is not null or undefined
            assertParamExists('searchExtraCommissionMemberCandidates', 'certificationId', certificationId)
            // verify required parameter 'stageId' is not null or undefined
            assertParamExists('searchExtraCommissionMemberCandidates', 'stageId', stageId)
            const localVarPath = `/api/v2/certifications/{certificationId}/stages/{stageId}/exam/extra-commission-members/available-users`
                .replace(`{${"certificationId"}}`, encodeURIComponent(String(certificationId)))
                .replace(`{${"stageId"}}`, encodeURIComponent(String(stageId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Idempotent — sending the same roles again leaves the entry unchanged.
         * @summary Add a person to the extra commission members or change their commission roles
         * @param {number} certificationId 
         * @param {number} stageId 
         * @param {string} userId 
         * @param {UpsertExtraCommissionMemberRequestDto} upsertExtraCommissionMemberRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        upsertExtraCommissionMember: async (certificationId: number, stageId: number, userId: string, upsertExtraCommissionMemberRequestDto: UpsertExtraCommissionMemberRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'certificationId' is not null or undefined
            assertParamExists('upsertExtraCommissionMember', 'certificationId', certificationId)
            // verify required parameter 'stageId' is not null or undefined
            assertParamExists('upsertExtraCommissionMember', 'stageId', stageId)
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('upsertExtraCommissionMember', 'userId', userId)
            // verify required parameter 'upsertExtraCommissionMemberRequestDto' is not null or undefined
            assertParamExists('upsertExtraCommissionMember', 'upsertExtraCommissionMemberRequestDto', upsertExtraCommissionMemberRequestDto)
            const localVarPath = `/api/v2/certifications/{certificationId}/stages/{stageId}/exam/extra-commission-members/{userId}`
                .replace(`{${"certificationId"}}`, encodeURIComponent(String(certificationId)))
                .replace(`{${"stageId"}}`, encodeURIComponent(String(stageId)))
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(upsertExtraCommissionMemberRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ExtraCommissionMembersApi - functional programming interface
 * @export
 */
export const ExtraCommissionMembersApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ExtraCommissionMembersApiAxiosParamCreator(configuration)
    return {
        /**
         * People a certification admin added to the commission pool of this EXAM stage on top of the supervisor relations configured in the stage config. While a person is on the list of any certification they hold `certification.exam.day.management` and `admin.panel.access`, and the exam day permission is effective in every stage whose list they are on. 
         * @summary List extra commission members of the exam stage
         * @param {number} certificationId 
         * @param {number} stageId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getExtraCommissionMembers(certificationId: number, stageId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ExtraCommissionMembersResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getExtraCommissionMembers(certificationId, stageId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ExtraCommissionMembersApi.getExtraCommissionMembers']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Refused with 409 while the person sits on the commission of an exam day of this stage that is still DRAFT or IN_PROGRESS. Removing a person who is not on the list is a no-op. 
         * @summary Remove a person from the extra commission members
         * @param {number} certificationId 
         * @param {number} stageId 
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async removeExtraCommissionMember(certificationId: number, stageId: number, userId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.removeExtraCommissionMember(certificationId, stageId, userId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ExtraCommissionMembersApi.removeExtraCommissionMember']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Active accounts (enabled, with at least one active role), searched by first name, last name, email or SAP number. `extraMember` is true for people already on this stage\'s list. 
         * @summary Search accounts that can be added as extra commission members
         * @param {number} certificationId 
         * @param {number} stageId 
         * @param {string} [search] 
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async searchExtraCommissionMemberCandidates(certificationId: number, stageId: number, search?: string, page?: number, size?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CommissionCandidatesResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.searchExtraCommissionMemberCandidates(certificationId, stageId, search, page, size, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ExtraCommissionMembersApi.searchExtraCommissionMemberCandidates']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Idempotent — sending the same roles again leaves the entry unchanged.
         * @summary Add a person to the extra commission members or change their commission roles
         * @param {number} certificationId 
         * @param {number} stageId 
         * @param {string} userId 
         * @param {UpsertExtraCommissionMemberRequestDto} upsertExtraCommissionMemberRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async upsertExtraCommissionMember(certificationId: number, stageId: number, userId: string, upsertExtraCommissionMemberRequestDto: UpsertExtraCommissionMemberRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ExtraCommissionMemberDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.upsertExtraCommissionMember(certificationId, stageId, userId, upsertExtraCommissionMemberRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ExtraCommissionMembersApi.upsertExtraCommissionMember']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ExtraCommissionMembersApi - factory interface
 * @export
 */
export const ExtraCommissionMembersApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ExtraCommissionMembersApiFp(configuration)
    return {
        /**
         * People a certification admin added to the commission pool of this EXAM stage on top of the supervisor relations configured in the stage config. While a person is on the list of any certification they hold `certification.exam.day.management` and `admin.panel.access`, and the exam day permission is effective in every stage whose list they are on. 
         * @summary List extra commission members of the exam stage
         * @param {number} certificationId 
         * @param {number} stageId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getExtraCommissionMembers(certificationId: number, stageId: number, options?: RawAxiosRequestConfig): AxiosPromise<ExtraCommissionMembersResponseDto> {
            return localVarFp.getExtraCommissionMembers(certificationId, stageId, options).then((request) => request(axios, basePath));
        },
        /**
         * Refused with 409 while the person sits on the commission of an exam day of this stage that is still DRAFT or IN_PROGRESS. Removing a person who is not on the list is a no-op. 
         * @summary Remove a person from the extra commission members
         * @param {number} certificationId 
         * @param {number} stageId 
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeExtraCommissionMember(certificationId: number, stageId: number, userId: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.removeExtraCommissionMember(certificationId, stageId, userId, options).then((request) => request(axios, basePath));
        },
        /**
         * Active accounts (enabled, with at least one active role), searched by first name, last name, email or SAP number. `extraMember` is true for people already on this stage\'s list. 
         * @summary Search accounts that can be added as extra commission members
         * @param {number} certificationId 
         * @param {number} stageId 
         * @param {string} [search] 
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchExtraCommissionMemberCandidates(certificationId: number, stageId: number, search?: string, page?: number, size?: number, options?: RawAxiosRequestConfig): AxiosPromise<CommissionCandidatesResponseDto> {
            return localVarFp.searchExtraCommissionMemberCandidates(certificationId, stageId, search, page, size, options).then((request) => request(axios, basePath));
        },
        /**
         * Idempotent — sending the same roles again leaves the entry unchanged.
         * @summary Add a person to the extra commission members or change their commission roles
         * @param {number} certificationId 
         * @param {number} stageId 
         * @param {string} userId 
         * @param {UpsertExtraCommissionMemberRequestDto} upsertExtraCommissionMemberRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        upsertExtraCommissionMember(certificationId: number, stageId: number, userId: string, upsertExtraCommissionMemberRequestDto: UpsertExtraCommissionMemberRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<ExtraCommissionMemberDto> {
            return localVarFp.upsertExtraCommissionMember(certificationId, stageId, userId, upsertExtraCommissionMemberRequestDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ExtraCommissionMembersApi - interface
 * @export
 * @interface ExtraCommissionMembersApi
 */
export interface ExtraCommissionMembersApiInterface {
    /**
     * People a certification admin added to the commission pool of this EXAM stage on top of the supervisor relations configured in the stage config. While a person is on the list of any certification they hold `certification.exam.day.management` and `admin.panel.access`, and the exam day permission is effective in every stage whose list they are on. 
     * @summary List extra commission members of the exam stage
     * @param {number} certificationId 
     * @param {number} stageId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ExtraCommissionMembersApiInterface
     */
    getExtraCommissionMembers(certificationId: number, stageId: number, options?: RawAxiosRequestConfig): AxiosPromise<ExtraCommissionMembersResponseDto>;

    /**
     * Refused with 409 while the person sits on the commission of an exam day of this stage that is still DRAFT or IN_PROGRESS. Removing a person who is not on the list is a no-op. 
     * @summary Remove a person from the extra commission members
     * @param {number} certificationId 
     * @param {number} stageId 
     * @param {string} userId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ExtraCommissionMembersApiInterface
     */
    removeExtraCommissionMember(certificationId: number, stageId: number, userId: string, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * Active accounts (enabled, with at least one active role), searched by first name, last name, email or SAP number. `extraMember` is true for people already on this stage\'s list. 
     * @summary Search accounts that can be added as extra commission members
     * @param {number} certificationId 
     * @param {number} stageId 
     * @param {string} [search] 
     * @param {number} [page] 
     * @param {number} [size] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ExtraCommissionMembersApiInterface
     */
    searchExtraCommissionMemberCandidates(certificationId: number, stageId: number, search?: string, page?: number, size?: number, options?: RawAxiosRequestConfig): AxiosPromise<CommissionCandidatesResponseDto>;

    /**
     * Idempotent — sending the same roles again leaves the entry unchanged.
     * @summary Add a person to the extra commission members or change their commission roles
     * @param {number} certificationId 
     * @param {number} stageId 
     * @param {string} userId 
     * @param {UpsertExtraCommissionMemberRequestDto} upsertExtraCommissionMemberRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ExtraCommissionMembersApiInterface
     */
    upsertExtraCommissionMember(certificationId: number, stageId: number, userId: string, upsertExtraCommissionMemberRequestDto: UpsertExtraCommissionMemberRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<ExtraCommissionMemberDto>;

}

/**
 * ExtraCommissionMembersApi - object-oriented interface
 * @export
 * @class ExtraCommissionMembersApi
 * @extends {BaseAPI}
 */
export class ExtraCommissionMembersApi extends BaseAPI implements ExtraCommissionMembersApiInterface {
    /**
     * People a certification admin added to the commission pool of this EXAM stage on top of the supervisor relations configured in the stage config. While a person is on the list of any certification they hold `certification.exam.day.management` and `admin.panel.access`, and the exam day permission is effective in every stage whose list they are on. 
     * @summary List extra commission members of the exam stage
     * @param {number} certificationId 
     * @param {number} stageId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ExtraCommissionMembersApi
     */
    public getExtraCommissionMembers(certificationId: number, stageId: number, options?: RawAxiosRequestConfig) {
        return ExtraCommissionMembersApiFp(this.configuration).getExtraCommissionMembers(certificationId, stageId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Refused with 409 while the person sits on the commission of an exam day of this stage that is still DRAFT or IN_PROGRESS. Removing a person who is not on the list is a no-op. 
     * @summary Remove a person from the extra commission members
     * @param {number} certificationId 
     * @param {number} stageId 
     * @param {string} userId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ExtraCommissionMembersApi
     */
    public removeExtraCommissionMember(certificationId: number, stageId: number, userId: string, options?: RawAxiosRequestConfig) {
        return ExtraCommissionMembersApiFp(this.configuration).removeExtraCommissionMember(certificationId, stageId, userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Active accounts (enabled, with at least one active role), searched by first name, last name, email or SAP number. `extraMember` is true for people already on this stage\'s list. 
     * @summary Search accounts that can be added as extra commission members
     * @param {number} certificationId 
     * @param {number} stageId 
     * @param {string} [search] 
     * @param {number} [page] 
     * @param {number} [size] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ExtraCommissionMembersApi
     */
    public searchExtraCommissionMemberCandidates(certificationId: number, stageId: number, search?: string, page?: number, size?: number, options?: RawAxiosRequestConfig) {
        return ExtraCommissionMembersApiFp(this.configuration).searchExtraCommissionMemberCandidates(certificationId, stageId, search, page, size, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Idempotent — sending the same roles again leaves the entry unchanged.
     * @summary Add a person to the extra commission members or change their commission roles
     * @param {number} certificationId 
     * @param {number} stageId 
     * @param {string} userId 
     * @param {UpsertExtraCommissionMemberRequestDto} upsertExtraCommissionMemberRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ExtraCommissionMembersApi
     */
    public upsertExtraCommissionMember(certificationId: number, stageId: number, userId: string, upsertExtraCommissionMemberRequestDto: UpsertExtraCommissionMemberRequestDto, options?: RawAxiosRequestConfig) {
        return ExtraCommissionMembersApiFp(this.configuration).upsertExtraCommissionMember(certificationId, stageId, userId, upsertExtraCommissionMemberRequestDto, options).then((request) => request(this.axios, this.basePath));
    }
}

